import React from "react";

import MuiLink from "@mui/material/Link";
import NextLink from "next/link";

export interface LinkProps {
    href?: string;
    to?: string;
    url?: string;

    target?: string;
    rel?: string;

    underline?: "none" | "hover" | "always";

    children?: React.ReactNode;

    [key: string]: any;
}

export const Link = ({
                         href,
                         to,
                         url,

                         target,
                         rel,

                         underline = "none",

                         children,

                         ...props
                     }: LinkProps & any) => {
    const linkHref = to || href || url || "/";

    const isExternal =
        typeof linkHref === "string" &&
        (linkHref.startsWith("http://") || linkHref.startsWith("https://"));

    return (
        <MuiLink
            component={NextLink}
            href={linkHref}
            target={
                target ||
                (isExternal ? "_blank" : undefined)
            }
            rel={
                rel ||
                (isExternal
                    ? "noopener noreferrer"
                    : undefined)
            }
            underline={underline}
            {...props}
        >
            {children}
        </MuiLink>
    );
};

export default Link;
